
const sortByCreated = (item: any): any => {
    return item.slice().sort((a:any, b:any) => {
      return new Date(b.created).getTime() - new Date(a.created).getTime();
    });
  };

  export default sortByCreated;